// Cookie
// 1 Day = 86400
// 1 Week = 604800
// 1 Month = 2592000
// 1 Year = 31536000
console.log("geolocation script loaded");

const cookieDuration = '604800'; // Duration of the cookie in seconds

const params = ['default=yes']; // Array of paramaters to add when redirecting

const urlParams = new URLSearchParams(
	window.location.search
); // Get URL parameters

const currentURL = window.location.href;

const geolocationDialog = document.getElementById(
	'geolocation-dialog'
); // Location popup wrapper

/**
 * Adds a cookie with the specified duration to the document if one does not already exist
 */
function addCookie(cookieDuration) {
	if (!document.cookie.includes('popupClosed=true')) {
		document.cookie = `popupClosed=true; max-age=${cookieDuration}`;
	}
}

const userAgent = navigator.userAgent;

const googleAdsBotUserAgents = [
	'AdsBot-Google (+http://www.google.com/adsbot.html)',
	'AdsBot-Google-Mobile (+http://www.google.com/mobile/adsbot.html)',
	'AdsBot-Google-Mobile-Apps',
];

/**
 * Adds a function to check and apply US visitor class
 */
function checkAndApplyUSVisitor() {
	if (document.cookie.includes('isUSVisitor=true')) {
		document.body.classList.add('is-us-visitor');
	}
}

// Run this check immediately, outside of any conditions
checkAndApplyUSVisitor();

if (
	urlParams.get('default') === 'yes' // Check if the user was redirected already
) {
	// Add cookies to not show the popup for a week
	addCookie(cookieDuration);
} else if (
	document.cookie.includes('popupClosed=true') || // Check if 'popupClosed' cookie is set to 'true'
	googleAdsBotUserAgents.includes(userAgent) ||
	parent.document.URL.includes('shopify')
) {
	// Do nothing..
} else {
	/**
	 * Redirects the current page to the specified URL if certain conditions are met.
	 */
	function autoRedirect(redirectUrl) {
		if (
			!currentURL.startsWith(redirectUrl) &&
			currentURL.includes('corston.')
		) {
			window.location.href = `${redirectUrl}/?${params.join(
				'&'
			)}`;
		}
	}

	/**
	 * Displays a location popup with geolocation options.
	 */
	function showLocationPopup(countryTheme) {
		const continueBtn = document.getElementById(
			'location-continue-btn'
		);
		const countrySelect = document.getElementById(
			'country-select'
		);

		const supportUrl = () => {
			// Check if the current URL contains any of the following paths and return the path in the redirect
			if (currentURL.includes('/pages/support')) {
				return 'pages/support/';
			} else if (
				currentURL.includes('/pages/environmental-policy')
			) {
				return 'pages/environmental-policy';
			} else {
				return '';
			}
		};

		continueBtn.href = `${
			countryTheme.url
		}/${supportUrl()}?${params.join('&')}`;
		countrySelect.value = countryTheme.label;

		// Change the continue button href when the country select is changed
		countrySelect.addEventListener('change', function () {
			const selectedCountry = $(this)
				.find(':selected')
				.data('url');
			continueBtn.href = `${selectedCountry}/?${params.join(
				'&'
			)}`;
		});

		// Add cookie when continue button is clicked
		continueBtn.addEventListener('click', function () {
			addCookie(cookieDuration);
		});

		// Show the geolocation dialog
		geolocationDialog.style.display = 'flex';

		// Add 'no-scroll' class to body to prevent scrolling while the popup is active
		document.body.classList.add('no-scroll');
	}

	/**
	 * Change the United Kingdom option to International for users outside Europe
	 */
	function setInternationalPopup() {
		// Store the international redirect info
		const intTheme = window.theme.redirect.int;
		const intLabel = intTheme.label;

		// Set the UK option to International then show the popup
		const ukOption = document.getElementById('UK-redirect');
		ukOption.value = intLabel;
		ukOption.textContent = `🇬🇧 ${intLabel}`;
		showLocationPopup(intTheme);
	}

	/**
	 * Adds a cookie with the specified duration to the document if one does not already exist
	 */
	function addUSVisitorCookie(cookieDuration) {
		if (!document.cookie.includes('isUSVisitor=true')) {
			document.cookie = `isUSVisitor=true; max-age=${cookieDuration}`;
		}
	}

	/**
	 * Retrieves the user's country information and performs actions based on the country and response status.
	 */
	async function getCountry() {
		try {
			// Check if we already know they're a US visitor
			if (document.cookie.includes('isUSVisitor=true')) {
				document.body.classList.add('is-us-visitor');
			}

			const response = await fetch(
				'https://api.ipgeolocation.io/ipgeo?apiKey=5acf21b7bc0f4238b6e885d4ffe0d88f&fields=country_code2,is_eu'
			);
			const data = await response.json();

			// If user is from United States
			if (data.country_code2 === 'US') {
				document.body.classList.add('is-us-visitor');
				addUSVisitorCookie(cookieDuration);
			}

			// console.log('COUNTRY DATA: ', data);

			if (response.status === 200) {
				// Find the country object which contains the users country code
				const countryTheme = Object.values(
					theme.redirect
				).find(item =>
					item.countries.includes(
						data.country_code2.toLowerCase()
					)
				);

				if (countryTheme) {
					switch (countryTheme.type) {
						case 'auto-redirect':
							autoRedirect(countryTheme.url);
							break;
						case 'popup':
							showLocationPopup(countryTheme);
							break;
						case 'no-redirect':
							addCookie(cookieDuration);
							break;
						default:
							console.log('DEFAULT CASE');
					}
				} else if (
					!data.is_eu &&
					!currentURL.startsWith(
						'https://www.corston.com'
					) &&
					!currentURL.includes('shopify')
				) {
					setInternationalPopup();
				} else if (
					currentURL.startsWith('https://www.corston.com')
				) {
					// do nothing
				} else {
					showLocationPopup(theme.redirect.uk);
				}
			} else {
				console.log(
					'Geolocation API not found: status ',
					response.status
				);
			}
		} catch (error) {
			console.log('GEOLOCATION API ERROR: ', error);
		}
	}

	window.addEventListener('load', getCountry);

	/**
	 * When popup close button is clicked then add a cookie and hide the popup
	 */
	function closePopup() {
		addCookie(cookieDuration);
		document.body.classList.remove('no-scroll');
		geolocationDialog.style.display = 'none';
	}
}
